import { IconCheckmarkCircleFilled } from '@zillow/constellation-icons';
import { Box, Heading, Icon, Text } from '@zillow/constellation-10';

type IntermediateStepProps = {
  headingText: string;
  headingLevel: 3 | 4;
  bodyText?: string;
  children: null | React.ReactNode;
};

const IntermediateStep = ({ headingLevel = 3, headingText, bodyText = '', children = null }: IntermediateStepProps) => (
  <Box css={{ marginTop: '200', marginBottom: '600' }}>
    <Icon size="lg" css={{ color: 'icon.accent.green.hero' }}>
      <IconCheckmarkCircleFilled />
    </Icon>
    <Box css={{ paddingTop: '600' }}>
      <Heading level={headingLevel}>{headingText}</Heading>
    </Box>
    {bodyText && (
      <Box css={{ paddingTop: '600' }}>
        <Text>{bodyText}</Text>
      </Box>
    )}
    {children && <Box css={{ paddingTop: '600' }}>{children}</Box>}
  </Box>
);

export default IntermediateStep;
